interface Option {
  label: string
  value?: string
}

interface Props {
  label: string
  id: string
  options: Option[]
  name?: string
}

const Select = ({ label, id, options, name }: Props) => (
  <>
    <label htmlFor="enquiryType" hidden className="hidden">
      {label}
    </label>
    <select
      id={id}
      name={name || id}
      className="border border-[#4A4D4E] bg-black text-[13px] rounded px-[26px] h-11 text-white w-full mb-4 focus:border-[#6ebb1d] outline-none appearance-none"
      required
    >
      {options.map(({ label, value }) => (
        <option key={label} value={value || ''}>
          {label}
        </option>
      ))}
    </select>
  </>
)

export default Select
